const HEADER_HIDDEN_TRANSFORM = 'translate3d(0, calc(-100% - 1rem), 0)';
const HEADER_VISIBLE_TRANSFORM = 'translate3d(0, 0, 0)';
const SCROLL_DELTA_THRESHOLD = 8;
const TOP_REVEAL_OFFSET = 24;

const hasOpenDrawer = () => {
  if (!document.body) {
    return false;
  }

  return Array.from(document.body.classList).some((className) =>
    className.startsWith('showing-popup-drawer')
  );
};

const applyHeaderState = (header, shouldHide) => {
  header.dataset.peHeaderHidden = shouldHide ? 'true' : 'false';
  header.style.transform = shouldHide ? HEADER_HIDDEN_TRANSFORM : HEADER_VISIBLE_TRANSFORM;
  header.style.opacity = shouldHide ? '0' : '1';
  header.style.pointerEvents = shouldHide ? 'none' : '';
};

export const initHeaderReveal = () => {
  const header = document.querySelector('#masthead');

  if (!header || header.dataset.peHeaderRevealInit === 'true') {
    return;
  }

  header.dataset.peHeaderRevealInit = 'true';
  header.style.willChange = 'transform, opacity';
  header.style.transition = 'transform 280ms ease, opacity 200ms ease';
  header.style.transform = HEADER_VISIBLE_TRANSFORM;
  header.style.opacity = '1';

  let lastScrollY = window.scrollY;
  let ticking = false;

  const syncHeader = () => {
    const currentScrollY = Math.max(window.scrollY, 0);
    const delta = currentScrollY - lastScrollY;
    const hideOffset = header.offsetHeight + TOP_REVEAL_OFFSET;

    if (currentScrollY <= TOP_REVEAL_OFFSET || hasOpenDrawer()) {
      applyHeaderState(header, false);
      lastScrollY = currentScrollY;
      return;
    }

    if (Math.abs(delta) < SCROLL_DELTA_THRESHOLD) {
      return;
    }

    if (delta > 0 && currentScrollY > hideOffset) {
      applyHeaderState(header, true);
    } else if (delta < 0) {
      applyHeaderState(header, false);
    }

    lastScrollY = currentScrollY;
  };

  const onScroll = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(() => {
      syncHeader();
      ticking = false;
    });
  };

  syncHeader();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', syncHeader, { passive: true });
};
